// Id acak per browser, dikirim saat login agar BE mengenali login ulang dari browser yang sama (#86).
// Disimpan permanen: JANGAN ikut terhapus saat logout / force logout (pakai clearLocalStorageKeepDevice).
export const DEVICE_ID_KEY = 'hydro:deviceId';

const randomId = () => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
};

export const getDeviceId = () => {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = randomId();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return null; // storage diblok: BE menganggap device tidak dikenal
  }
};

// Pengganti localStorage.clear() yang mempertahankan deviceId.
export const clearLocalStorageKeepDevice = () => {
  let id = null;
  try {
    id = localStorage.getItem(DEVICE_ID_KEY);
  } catch {
    /* storage diblok */
  }
  localStorage.clear();
  if (id) localStorage.setItem(DEVICE_ID_KEY, id);
};
